import axios from "axios";
import { ENV_REACT_APP } from "../Configurations/ENV_Config";
import { getToken } from "../Utils/tokenStorage";

const apiBase = (path: string) =>
  `${ENV_REACT_APP?.REACT_APP_API_BASE_URL || ""}${path}`;

/**
 * Owner sets (or clears, with null) the date the home-anniversary card counts
 * from. "YYYY-MM-DD". Owner-only on the server.
 */
export const setOwnedSince = async (propertyId: string, ownedSince: string | null): Promise<void> => {
  const t = getToken();
  await axios.patch(
    apiBase(`/api/user/property/${encodeURIComponent(propertyId)}/owned-since`),
    { ownedSince },
    { headers: t ? { Authorization: `Bearer ${t}` } : {} }
  );
};
